import TYPES from './types';
import COMMON_TYPES from '../../../actions/types';
import { showNotificationLayer } from '../../../actions/notification';
import { deleteAnswerSurvey } from '../../../api/survey';
import { remove as d } from '../../../api/common';

const loadingPostDeleteToggle = () => ({
  type: TYPES.loadingFormDelete,
});

export const remove = params => {
  return dispatch => {
    dispatch(loadingPostDeleteToggle());

    d(params.formParams.id, 'survey.php')
      .then(() => {
        dispatch(loadingPostDeleteToggle());

        dispatch(
          showNotificationLayer(`A enquete ${params.formParams.reference} foi removida!`)
        );
      })
      .then(() => { params.callbackSuccess(); })
      .catch(responseFail => {
        dispatch(loadingPostDeleteToggle());

        dispatch({
          type: TYPES.formPostDeleteError,
          payload: responseFail.response,
        });
      })
  }
}

export const removeAnswer = params => {
  return dispatch => {
    dispatch(loadingPostDeleteToggle());

    deleteAnswerSurvey(params.formParams.id)
      .then(() => {
        dispatch(loadingPostDeleteToggle());

        dispatch(
          showNotificationLayer(`As respostas da enquete ${params.formParams.reference} foram removidas!`)
        );
      })
      .then(() => { params.callbackSuccess(); })
      .catch(responseFail => {
        dispatch(loadingPostDeleteToggle());

        dispatch({
          type: TYPES.formPostDeleteError,
          payload: responseFail.response,
        });
      })
  }
}

export const toggleFormDeleteLayer = params => {
  if(params && params.id) {
    return [
      { type: COMMON_TYPES.toggleLayer, payload: 'delete' },
      { type: TYPES.setDataFormDelete, payload: params },
    ];
  }

  return { type: COMMON_TYPES.toggleLayer, payload: null };
};
